import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import axios from "axios";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { createOrganizerCoupon ,getAllTicketBySlug, updateOrganizerCoupon,deleteCoupon} from "../../../api";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import ListCard from "../../../components/common/ListCard/ListCard";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  FormFeedback,
  Label,
  Form,
} from "reactstrap";
const API_URL = "https://apiqa.eventox.co/api/coupon";

interface Coupon {
  couponId: number;
  code: string;
  discount: number;
  discountType: string;
  maxCount: number;
  totalUsed: number;
  eventName: string;
  ticketType: string;
  createdAt: string;
  status: string;
  TicketType?: {
    ticketType: string;
    Venue?: {
      venueName: string;
    };
  };
}

const UserCoupons: React.FC = () => {
  const { slug } = useParams();
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [search, setSearch] = useState<string>("");
  const [modal, setModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [ticketList, setTicketList] = useState<any[]>([]);
  const toggle = () => setModal(!modal);
  const [editModal, setEditModal] = useState<boolean>(false);
  const [editCoupon, setEditCoupon] = useState<Coupon>({} as Coupon);
  const toggleEditModal = () => setEditModal(!editModal);
  const [selectedTicketFilter, setSelectedTicketFilter] = useState<string>("all");
  useEffect(() => {
    getCouponsList();
    getTicketList();
  }, []);

  const getCouponsList = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get<Coupon[]>(API_URL);
      const eventData = localStorage.getItem("eventData");
  
      if (eventData) {
        const { eventId } = JSON.parse(eventData);
          const filteredCoupons = response.data.filter(
          (coupon: any) => coupon.Event?.eventId === eventId
        );
        setCoupons(filteredCoupons);
      } else {
        setCoupons([]);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getTicketList = async () => {
  const eventData = localStorage.getItem("eventData");
  const venueId = localStorage.getItem("venueId");
  try {
    setIsLoading(true);
    if (eventData && venueId) {
      const eventSlug = JSON.parse(eventData).slugId;
      const response = await getAllTicketBySlug(eventSlug);
      const filteredTickets = response.filter((ticket: any) => ticket.venueId === venueId);
      setTicketList(filteredTickets);
    }
  } catch (error) {
    console.error("Error fetching tickets:", error);
  } finally {
    setIsLoading(false);
  }
};

  const validation = useFormik({
    initialValues: {
      code: "",
      discount: "",
      discountType: "percentage",
      status: "active",
      ticketType: "",
      maxCount: "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Coupon Code is required"),
      discount: Yup.number().required("Discount is required"),
      maxCount: Yup.number().required("Max Count is required"),
      ticketType: Yup.string().required("Ticket Type is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventId = JSON.parse(eventData).eventId;
          const payload = {
            ...values,
            eventId,
            ticketTypeId: values.ticketType,
            status: "active",
          discountType: "percentage", 
          };
          const response = await createOrganizerCoupon(payload);
          toast.success("Coupon created successfully!");
          resetForm();
          toggle();
          getCouponsList();
        }
      } catch (error) {
        console.error("Error creating Coupon:", error);
        toast.error("Error creating Coupon. Please try again.");}
        finally{
          setIsLoading(false);
        }
    },
  });
  const updateCoupon = async () => {
    try {
      setIsLoading(true);
      const payload = {
        ...editCoupon,
        status: editCoupon.status,
      };
      const response = await updateOrganizerCoupon(editCoupon.couponId, payload);
      toast.success("Coupon updated successfully!");
      toggleEditModal();
      getCouponsList();
    } catch (error) {
      console.error("Error updating Coupon:", error);
    }
    finally {
      setIsLoading(false);
    }
  };
  const handleDelete = async (row: any) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      try {
        const response = await deleteCoupon(row.couponId);
        toast.success("Coupon deleted successfully!");
        getCouponsList();
      } catch (error:any) {
       const errorMsg = error.response?.data?.message ||
               "Failed to delete coupon.";
             toast.error(errorMsg);
      }
    }
  };

  const columns = [ 
    { label: "Coupon Code", key: "code" },
    { label: "Discount", key: "discount" },
    { label: "Discount Type", key: "discountType" },
    { label: "Max Count", key: "maxCount" },
    { label: "Total Used", key: "totalUsed" },
    {
      label: "Ticket",
      key: "ticketType",
      cellContent: (row: any) => <span>{row?.TicketType?.ticketType + " (" + row?.TicketType?.Venue?.venueName + ")"}</span>,
    },
    { label: "Created At", key: "createdAt",
      cellContent: (row: any) => <FormattedDate dateString={row?.createdAt} />
     },
    { label: "Status", key: "status", cellContent: (row: any) => <span className={row?.status === "active" ? "text-success" : "text-danger"}>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}</span> },
    {
      label: "",
      key: "edit",
      cellContent: (row: any) => (
        <span className="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
        <span className="text-primary"
          onClick={() => handleEdit(row)} >
          <i className="fa-solid fa-pencil"></i>
        </span>
         <span className="text-danger"
          onClick={() => handleDelete(row)} >
          <i className="fa-solid fa-trash"></i>
        </span>
        </span>
      ),
    },
  ];

  const handleEditChange = (e: any) => {
    setEditCoupon({ ...editCoupon, [e.target.name]: e.target.value });
  };
  const handleEdit = (row: any) => {
    setEditCoupon(row);
    toggleEditModal();
  };
  const handleSearch = (e: any) => {
    const value = e.target.value;
    setSearch(value);
    if (value.length > 0) {
      const filtered = coupons.filter((coupon) =>
        (coupon.code ?? "").toLowerCase().startsWith(value.toLowerCase())
      );
      setCoupons(filtered);
    } else {
      getCouponsList();
    }
  };

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <div className="modal-dialog ms-5">
                <h3>
                  <i className="mx-2">
                    <i className="fa-solid fa-ticket"></i>
                  </i>
                  Coupon List
                </h3>
              </div>
            </div>
            <div className="col-md-12">
              <div className="main-card mt-5">
                <div className="dashboard-wrap-content p-2">
                  <div className="d-md-flex flex-wrap align-items-center">
                    <div className="dashboard-date-wrap mt-4">
                      <div className="form-group">
                        <div className="relative-input position-relative">
                          <input
                            className="form-control h_40"
                            type="text"
                            placeholder="Search by Coupon Code"
                            value={search}
                            onChange={handleSearch}
                          />
                          <i className="uil uil-search"></i>
                        </div>
                      </div>
                    </div>
                    <div className="rs ms-auto mt-4">
                      <Button color="danger" onClick={toggle}>
                        <i className="fa-solid fa-plus"></i>
                        <span className="ms-2">Add New Coupon</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              {/* {isLoading ? (
                <div className="d-flex justify-content-center py-4">
                  <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                </div>
              ) : (
                <div className="event-list">
                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="orders-tab"
                      role="tabpanel"
                    >
                      <NormalTable columns={columns} data={coupons} getRowId={(row: any) => row.couponId} />
                    </div>
                  </div>
                </div>
              )} */}
              {ticketList.length > 0 && (
                <div className="d-flex align-items-center gap-2 flex-wrap mt-3 mb-2 ms-1">
                  <span className="text-muted fs-12 fw-semibold me-1">
                    <i className="fa-solid fa-filter me-1"></i>Filter by Ticket:
                  </span>
                  <button
                    type="button"
                    className={`btn btn-sm ${selectedTicketFilter === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    style={{ borderRadius: '20px', fontSize: '11px', padding: '4px 12px', fontWeight: 600 }}
                    onClick={() => setSelectedTicketFilter('all')}
                  >
                    All Tickets ({coupons.length})
                  </button>
                  {ticketList.map((ticket: any) => {
                    const tId = String(ticket.ticketTypeId || ticket.id);
                    const count = coupons.filter((c: any) =>
                      String(c.TicketType?.ticketTypeId || c.ticketTypeId || c.TicketType?.id || "") === tId
                    ).length;
                    return (
                      <button
                        key={tId}
                        type="button"
                        className={`btn btn-sm ${selectedTicketFilter === tId ? 'btn-primary' : 'btn-outline-secondary'}`}
                        style={{ borderRadius: '20px', fontSize: '11px', padding: '4px 12px', fontWeight: 600 }}
                        onClick={() => setSelectedTicketFilter(tId)}
                      >
                        {ticket.ticketType || ticket.name} ({count})
                      </button>
                    );
                  })}
                </div>
              )}
              <div className="mt-4">
            {coupons.length > 0 ? (
              coupons
                .filter((coupon: any) => {
                  if (selectedTicketFilter === 'all') return true;
                  const couponTicketId = String(coupon.TicketType?.ticketTypeId || coupon.ticketTypeId || coupon.TicketType?.id || "");
                  return couponTicketId === selectedTicketFilter;
                })
                .map((coupon) => (
                <ListCard
                  key={coupon.couponId}
                  cardData={{
                    icon: "fa-solid fa-ticket",
                    name: coupon.code,
                    ticket: coupon.TicketType?.ticketType || "N/A",
                    startDate: coupon.createdAt,
                    status: coupon.status,
                    totalUsed: coupon.totalUsed,
                    totalLimit: coupon.maxCount,
                    discount: coupon.discount + (coupon.discountType === "percentage" ? "%" : ""),
                    isActive: coupon.status === "active",
                    optionHead: "Discount", 
                    option: coupon.discount + (coupon.discountType === "percentage" ? "%" : ""),
                  }}
                  onEdit={() => handleEdit(coupon)}
                  onDelete={() => handleDelete(coupon)}
                  onToggle={(val:any) => {
                    setEditCoupon({ ...coupon, status: val ? "active" : "inactive" });
                    updateCoupon();
                  }}
                />
              ))
            ) : (
              <p className="text-muted">No coupons available</p>
            )}
          </div>
            </div>
          </div>
        </div>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Add New Coupon</ModalHeader>
          <ModalBody className="p-4">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <FormGroup>
                <Label>Coupon Code</Label>
                <Input
                  name="code"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.code}
                  invalid={
                    !!(
                      validation.touched.code &&
                      validation.errors.code
                    )
                  }
                />
                <FormFeedback>{validation.errors.code}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Ticket</Label>
                <Input
                  type="select"
                  name="ticketType"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.ticketType}
                  invalid={
                    !!(validation.touched.ticketType && validation.errors.ticketType)
                  }
                >
                  <option value="">Select Ticket</option>
                  {ticketList.map((ticket: any) => (
                    <option key={ticket.ticketTypeId} value={ticket.ticketTypeId}>
  {`${ticket.ticketType}  ${ticket.venueId!=null ? "("+ticket['Venue.venueName']+")" : ""}`}
</option>


                  ))}
                </Input>
                <FormFeedback>{validation.errors.ticketType}</FormFeedback>
              </FormGroup>
              {/* <FormGroup>
                <Label>Discount Type</Label>
                <Input
                  type="select"
                  name="discountType"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.discountType}
                  invalid={
                    !!(
                      validation.touched.discountType &&
                      validation.errors.discountType
                    )
                  }
                >
                  <option value="">Select Discount Type</option>
                  <option value="percentage">Percentage</option>
                  <option value="fixed">Fixed</option> 
                </Input>
                <FormFeedback>{validation.errors.discountType}</FormFeedback>
              </FormGroup> */}

              <FormGroup>
                <Label>Discount</Label>
                <Input
                  name="discount"
                  type="text"
                  placeholder="Enter Discount Percentage"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.discount}
                  invalid={
                    !!(
                      validation.touched.discount && validation.errors.discount
                    )
                  }
                />
                <FormFeedback>{validation.errors.discount}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label>Max Count</Label>
                <Input
                  name="maxCount"
                  type="number"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.maxCount}
                  invalid={
                    !!(
                      validation.touched.maxCount && validation.errors.maxCount
                    )
                  }
                />
                <FormFeedback>{validation.errors.maxCount}</FormFeedback>
              </FormGroup>
              <ModalFooter>
                <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading}>
                   <h5>
                     {isLoading ? "Creating..." : "Create Coupon"}
                  </h5>
                </Button>
               
              </ModalFooter>
            </Form>
          </ModalBody>
        </Modal>
        <Modal isOpen={editModal} toggle={toggleEditModal}>
          <ModalHeader toggle={toggleEditModal}>Edit Coupon</ModalHeader>
          <ModalBody className="p-4">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                updateCoupon();
              }}
            >
              <FormGroup>
                <Label>Coupon Code</Label>
                <Input type="text" disabled name="code" value={editCoupon.code} onChange={handleEditChange} />
              </FormGroup>
              <FormGroup>
                <Label>Status</Label>
                <Input
                  type="select"
                  name="status"
                  onChange={handleEditChange}
                  value={editCoupon.status}
                >
                  <option value="">Select Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Input>
              </FormGroup>
              <ModalFooter>
                <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading}>
                  <h5>
                    {isLoading ? "Saving..." : "Save Changes"}
                  </h5>
                </Button>
              </ModalFooter>
            </Form>
          </ModalBody>
        </Modal>

      </div>
      <div>
        <ToastContainer
        autoClose={2000}
        />
      </div>
    </div>
  );
};
export default UserCoupons;
